import axios from "axios";
import {
  PDULI_RECORDING_FAIL,
  PDULI_RECORDING_REQUEST,
  PDULI_RECORDING_RESET,
  PDULI_RECORDING_SUCCESS,
} from "../constants/recordingConstants";
import { UserDatPduliaDecode } from "../function/base64Function";
import { API_START_RECORD_PDULI } from "../init/urlApi";

export const RStartRecordingPduli = (data) => async (dispatch) => {
  dispatch({
    type: PDULI_RECORDING_RESET,
  });
};

export const StartRecordingPduli = () => async (dispatch) => {
  const { token, typeUser, session } = UserDatPduliaDecode();

  try {
    dispatch({
      type: PDULI_RECORDING_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.post(
      API_START_RECORD_PDULI(typeUser),
      {
        sessionId: session,
      },
      config
    );
    dispatch({
      type: PDULI_RECORDING_SUCCESS,
      payload: data.data?.id,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: PDULI_RECORDING_FAIL,
      payload: message,
    });
  }
};
